const getApiBaseUrl = require('../config/apiBaseUrl').default;

function getBaseUrl() {
  return getApiBaseUrl() + '/api/v1';
}

function getTraderApiBase() {
  return getApiBaseUrl() + '/trader_app/api/v1';
}

// String constants (base URL) – exported as getters
const BASE_URL_PATHS = [
  ['SIGNIN_URL', '/admin/login/'],
  ['GET_OUTGROWER_URL', '/outgrowerscheme/'],
  ['GET_OUTGROWER_SCHEME_URL', '/outgrowerscheme/'],
  ['GET_SCHEME_APPLICATION_URL', '/get_scheme_applications/'],
  ['GET_FARMERS_URL', '/farmer/'],
  ['GET_FARM_URL', '/farm/'],
  ['GET_USERS_URL', '/userobject/'],
  ['GET_AGENTS_URL', '/agent/'],
  ['GET_COMPANIES_URL', '/company/'],
  ['REGISTER_ADMIN_URL', '/register/'],
  ['CROP_URL', '/crops/'],
  ['REGISTER_COMPANY_URL', '/company/'],
  ['COMPANY_SCHEME_URL', '/get_schemes_by_company_id/'],
  ['COMPANY_VERIFICATION_STATUS_URL', '/company/verification-status/'],
  ['REVIEW_COMPANY_VERIFICATION_URL', '/admin/company/review-verification/'],
  ['COMPANY_REPRESENTATIVES_URL', '/companyrepresentative/company/'],
  ['COMPANY_AGENT_URL', '/get_agents_by_company_id/'],
  ['COMPANY_FARMERS_URL', '/get_farmers_by_company_id/'],
  ['COMPANY_AGRONOMIST_URL', '/agronomist_by_company_id/'],
  ['COMPANY_AGRODEALER_URL', '/agrodealer_by_company_id/'],
  ['GET_CROPS_URL', '/crops/'],
  ['GET_SCHEME_APPS_BY_STATUS_URL', '/get_scheme_apps_by_status/'],
  ['GET_PROVINCES_URL', '/provinces/'],
  ['GET_HARVEST_URL', '/farmer_harvest/'],
  ['GET_HARVEST_BY_CROP_URL', '/farmer_harvest_by_crop/'],
  ['GET_CULTIVATION_AREA_URL', '/get_grand_total_cultivation_area/'],
  ['GET_FARMERS_BY_PROVINCE_URL', '/farmers_by_province/'],
  ['GET_FARMS_BY_PROVINCE_URL', '/farms_by_province/'],
  ['GET_INPUT_DELIVERY_URL', '/input_delivery/'],
  ['GET_FARM_INSPECTIONS_URL', '/farm-inspections/'],
  ['GET_ACTIVITY_LOG_URL', '/activity/'],
  ['GET_FARM_INSPECTION_VISITS_URL', '/farm-inspection-visits/'],
  ['GET_SCHEMES_URL', '/outgrowerscheme/'],
  ['GET_FARMER_COMPLAINTS_URL', '/farmer_complaints/'],
  ['GET_SUPPORT_EMAILS_URL', '/support_emails/'],
  ['GET_CULTIVATED_CROP_URL', '/cultivated_crop/'],
  ['GET_CROP_PROVINCIAL_AGG_URL', '/crop_provincial_agg/'],
  ['GET_FARMS_BY_FARMER_URL', '/get_farm_by_farmer_id/'],
  ['GET_SCHEME_APPLICATIONS_BY_FARMER_URL', '/get_scheme_applications_by_farmer_id/'],
  ['GET_INPUT_DELIVERY_BY_FARMER_URL', '/input_delivery_by_farmer/'],
  ['GET_HARVEST_BY_FARMER_URL', '/farmer_harvest_by_farmer/'],
  ['GET_FARMER_INPUT_HISTORY_URL', '/farmer-input-history/']
];

BASE_URL_PATHS.forEach(([name, path]) => {
  Object.defineProperty(exports, name, {
    get: () => getBaseUrl() + path,
    enumerable: true
  });
});

// String constants (trader API) – exported as getters
const TRADER_URL_PATHS = [
  ['GET_PRESEASON_CONTRACTS_URL', '/contracts/preseason/'],
  ['GET_PRESEASON_APPLICATIONS_URL', '/contracts/applications/'],
  ['GET_FINAL_CONTRACTS_URL', '/contracts/final/'],
  ['GET_TRADE_OFFERS_URL', '/trade_offers/'],
  ['GET_SELL_REQUESTS_URL', '/sell_requests/'],
  ['GET_PRODUCTS_URL', '/products/']
];

TRADER_URL_PATHS.forEach(([name, path]) => {
  Object.defineProperty(exports, name, {
    get: () => getTraderApiBase() + path,
    enumerable: true
  });
});

// Function exports (base URL)
exports.FARM_ID_URL = (id) => getBaseUrl() + '/farm/' + id + '/';
exports.GET_USERS_ROLE_URL = (role) => getBaseUrl() + '/get_user/?role=' + role;
exports.SEARCH_FARMER_URL = (query) => getBaseUrl() + '/search_users/?q=' + query;
exports.VERIFY_COMPANY_URL = (id) => getBaseUrl() + '/verify_company/' + id + '/';
exports.UNVERIFY_COMPANY_URL = (id) => getBaseUrl() + '/unverify_company/' + id + '/';
exports.SEARCH_COMPANY_URL = (query) => getBaseUrl() + '/search_company/?q=' + query;
exports.SEARCH_AGENT_URL = (id, query) => getBaseUrl() + '/search/agents_in_company/?q=' + query + '&pacra_id=' + id + '/';
exports.SEARCH_SCHEME_URL = (query) => getBaseUrl() + '/search/schemes/?q=' + query;
exports.SEARCH_AGRODEALER_URL = (query) => getBaseUrl() + '/search/agrodealers/?q=' + query;
exports.COMPANY_DATA_URL = (id) => getBaseUrl() + '/company/' + id + '/';
exports.USER_DATA_URL = (id) => getBaseUrl() + '/userobject/' + id + '/';
exports.COMPANY_ID_URL = (id) => getBaseUrl() + '/company/' + id + '/';
exports.INPUT_DELIVERY_ID_URL = (id) => getBaseUrl() + '/input_delivery/' + id + '/';
exports.FARM_INSPECTION_ID_URL = (id) => getBaseUrl() + '/farm-inspections/' + id + '/';

// Function exports (trader API)
exports.PRESEASON_CONTRACT_ID_URL = (id) => getTraderApiBase() + '/contracts/preseason/' + id + '/';
exports.PRESEASON_CONTRACT_PRICE_HISTORY_URL = (id) => getTraderApiBase() + '/contracts/preseason/' + id + '/price-history/';
exports.PRESEASON_CONTRACT_APPLICATION_PRICE_BUCKETS_URL = (id) =>
  getTraderApiBase() + '/contracts/preseason/' + encodeURIComponent(id) + '/application-price-buckets/';
exports.PRESEASON_CONTRACT_QUANTITY_HISTORY_URL = (id) => getTraderApiBase() + '/contracts/preseason/' + id + '/quantity-history/';
exports.TRADE_OFFER_ID_URL = (id) => getTraderApiBase() + '/trade_offers/' + id + '/';
exports.SELL_REQUEST_ID_URL = (id) => getTraderApiBase() + '/sell_requests/' + id + '/';
exports.PRODUCT_ID_URL = (id) => getTraderApiBase() + '/products/' + id + '/';

exports.GET_FARMER_INVENTORY_URL = (farmerId) => getBaseUrl() + '/get_farmer_input_inventory/' + farmerId + '/';
